import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import UpdateBanner from "./components/UpdateBanner";
import StagingBanner from "./components/StagingBanner";
import reportWebVitals from "./reportWebVitals";
import { initErrorTracking } from "./services/errorTracking";

initErrorTracking(); // no-op unless REACT_APP_SENTRY_DSN was set at build time

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StagingBanner />
    <UpdateBanner />
    <App />
  </React.StrictMode>,
);

reportWebVitals();
